<template>
  <div v-loading="loading" class="get-started-container">
    <div class="get-started step-1" v-if="step === 1">
      <header class="header flex flex-h-bet">
        <img
          :src="this.$user.getCompany().company_logo"
          alt
          class="company-logo"
        />
        <router-link
          class="btn btn-gray no-border"
          to="/companyurl"
          @click.native="logout()"
          >Log Out & Finish Later</router-link
        >
      </header>
      <aside class="aside center-text">
        <div class="flex flex-v-center flex-h-center">
          <img src="/img/main-clock.svg" alt="tams logo" class="logo" />
        </div>
      </aside>
      <main class="main">
        <h2 class="blue mb-20 no-bold">
          Welcome Aboard, {{ firstName }} {{ lastName }}
        </h2>
        <p>
          We are excited that you are joing us here at
          {{ $user.getCompany().company_name || "NA" }},. We can’t wait for you
          to start.
        </p>
        <p class="mt-20 mb-20">
          We have included some helpful information and ask that you complete
          your employee information forms that will appear on the next page.
          This will help you get started and hit the grounf running.
        </p>
        <p class="mb-20">
          If you have any questions please dont hesitate to ask.
        </p>

        <hr class="hr" />
        <div class="info mt-20">
          <div class="info-left">
            <h3 class="blue">Your First Day</h3>
            <div class="media-group flex-v-center flex mt-20">
              <img src="/img/calendar.svg" alt /> <span>NA</span>
            </div>
            <div class="media-group flex-v-center flex mt-20">
              <img src="/img/clock.svg" alt /> <span>NA</span>
            </div>
          </div>
          <div class="info-right pl-15 pr-15">
            <h3 class="blue">Documents to fill</h3>
            <div class="media-group mt-20">
              <img src="/img/file.svg" alt /> <span>Reference Forms</span>
              <a href class="smallest-text no-line blue">Download</a>
            </div>
            <div class="media-group mt-20">
              <img src="/img/file.svg" alt /> <span>Guarantors Forms</span>
              <a href class="smallest-text no-line blue">Download</a>
            </div>
            <div class="media-group mt-20">
              <img src="/img/file.svg" alt /> <span>Staff Bio-Data Form</span>
              <a href class="smallest-text no-line blue">Download</a>
            </div>
            <el-button
              class="btn btn-big btn-light-gray no-border btn-full-radius inline-flex flex-v-end float-r mt-60"
              @click.prevent="next()"
            >
              Continue >
            </el-button>
          </div>
        </div>
      </main>
    </div>

    <div class="get-started" v-show="step >= 2">
      <header class="header flex flex-h-bet">
        <img
          :src="this.$user.getCompany().company_logo"
          alt
          class="company-logo"
        />
        <a class="btn btn-gray no-border" href>Log Out & Finish Later</a>
      </header>
      <aside class="aside center-text">
        <div class="flex flex-v-center flex-h-center">
          <img src="/img/main-clock.svg" alt="tams logo" class="logo" />
        </div>
      </aside>
      <main class="main">
        <div>
          <el-form
            :model="createEmployeeForm"
            ref="createEmployeeForm"
            id="createEmployeeForm"
            :rules="rules"
            class="employee-form"
            label-position="left"
            label-width="220px"
            v-loading="loading"
            @submit.prevent.native="addEmployee"
          >
            <div class="step" v-show="step === 2">
              <h3 class="mt-0 mb-0 grid-full">{{ title }} Employee</h3>
              <div class="form-left">
                <h3>Personal Information</h3>
                <el-form-item prop="salutation" label="Salutation">
                  <el-select
                    v-model="createEmployeeForm.salutation"
                    placeholder="Salutation"
                  >
                    <el-option
                      v-for="item in salutationOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="first_name" label="First Name">
                  <el-input
                    placeholder="First Name"
                    v-model="createEmployeeForm.first_name"
                    type="text"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="last_name" label="Last Name" class="mt-20">
                  <el-input
                    placeholder="Last Name"
                    v-model="createEmployeeForm.last_name"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="date_of_birth" label="Date of birth">
                  <el-date-picker
                    v-model="createEmployeeForm.date_of_birth"
                    type="date"
                    placeholder="Pick a day"
                    format="dd-MM-yyyy"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="Blood Group" prop="blood_group">
                  <el-radio-group
                    label="Blood Group"
                    v-model="createEmployeeForm.blood_group"
                    fill="#066aff"
                    prop="blood_group"
                  >
                    <el-radio-button label="A+">A+</el-radio-button>
                    <el-radio-button label="A-">A-</el-radio-button>
                    <el-radio-button label="B+">B+</el-radio-button>
                    <el-radio-button label="B-">B-</el-radio-button>
                    <el-radio-button label="O+">O+</el-radio-button>
                    <el-radio-button label="O-">O-</el-radio-button>
                    <el-radio-button label="AB+">AB+</el-radio-button>
                    <el-radio-button label="AB-">AB-</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item prop="nationality" label="Nationality">
                  <el-input
                    placeholder="Nationality"
                    v-model="createEmployeeForm.nationality"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Gender" prop="gender">
                  <el-radio-group
                    label="Gender"
                    v-model="createEmployeeForm.gender"
                    fill="#066aff"
                    prop="gender"
                  >
                    <el-radio-button label="male">Male</el-radio-button>
                    <el-radio-button label="female">Female</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item prop="marital_status" label="Marital Status">
                  <el-select
                    v-model="createEmployeeForm.marital_status"
                    placeholder="Marital Status"
                    autocomplete="on"
                    filterable
                  >
                    <el-option
                      v-for="item in maritalStatusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Religion">
                  <el-radio-group
                    label="Religion"
                    v-model="createEmployeeForm.religion"
                    fill="#066aff"
                  >
                    <el-radio-button label="christianity"
                      >Christianity</el-radio-button
                    >
                    <el-radio-button label="islam">Islam</el-radio-button>
                    <el-radio-button label="others">Others</el-radio-button>
                    <!-- <el-form-item prop="nationality" label="Nationality"> -->
                    <el-input
                      v-if="createEmployeeForm.religion === 'others'"
                      class="ml-10"
                      placeholder="Type your religion"
                      :style="{ width: '200px !important' }"
                      v-model="othersText"
                    ></el-input>
                    <!-- </el-form-item> -->
                  </el-radio-group>
                </el-form-item>
                <h3>Contact Information</h3>
                <el-form-item
                  prop="email"
                  label="Email"
                  :rules="[
                    {
                      required: true,
                      message: 'Please input email address',
                      trigger: 'blur',
                    },
                    {
                      type: 'email',
                      message: 'Please input correct email address',
                      trigger: ['blur', 'change'],
                    },
                  ]"
                >
                  <el-input
                    placeholder="Email"
                    v-model="createEmployeeForm.email"
                    name="email"
                    type="email"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="mobile_number" label="Phone Number">
                  <VuePhoneNumberInput
                    v-model="createEmployeeForm.mobile_number"
                    @update="phoneFormatted"
                    default-country-code="NG"
                    :preferred-countries="['NG']"
                    color="#409EFF"
                    valid-color="#888"
                    @keypress.native="onlyNumbers"
                    placeholder="Type your phone number"
                  />
                </el-form-item>
                <el-form-item prop="mobile_number2" label="Phone Number 2">
                  <VuePhoneNumberInput
                    v-model="createEmployeeForm.mobile_number2"
                    default-country-code="NG"
                    :preferred-countries="['NG']"
                    color="#409EFF"
                    valid-color="#888"
                    @keypress.native="onlyNumbers"
                    placeholder="Type your phone number"
                  />
                </el-form-item>
                <el-form-item prop="address" label="House Address">
                  <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="House Address"
                    v-model="createEmployeeForm.address"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="country" label="country">
                  <el-select
                    v-model="createEmployeeForm.country"
                    placeholder="Country"
                    filterable
                    @change="getStates(createEmployeeForm.country)"
                  >
                    <el-option
                      v-for="country in countries"
                      :key="country.id + ''"
                      :label="country.name"
                      :value="country.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="state" label="State">
                  <el-select
                    v-model="createEmployeeForm.state"
                    placeholder="State"
                    @change="getCities(createEmployeeForm.state)"
                    filterable
                  >
                    <el-option
                      v-for="state in states"
                      :key="state.id + ''"
                      :label="state.name"
                      :value="state.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="city" label="City">
                  <el-select
                    v-model="createEmployeeForm.city"
                    placeholder="City"
                    filterable
                  >
                    <el-option
                      v-for="city in cities"
                      :key="city.id + ''"
                      :label="city.name + ''"
                      :value="city.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!-- <h3>ID Information</h3>
          <el-form-item prop="means_of_id" label="Means of Identification">
            <el-select v-model="value" placeholder="Means of Identification">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="ID Number">
            <el-input placeholder="ID Number" v-model="input"></el-input>
          </el-form-item>
          <el-form-item prop="expiry_date" label="Expiry Date">
            <el-date-picker v-model="date" type="date" placeholder="Pick a day"></el-date-picker>
          </el-form-item>
          <h3>Emergency Contact</h3>
          <el-form-item label="Contact's Name">
            <el-input placeholder="Contact's Name" v-model="input"></el-input>
          </el-form-item>
          <el-form-item prop="relationship" label="Relationship">
            <el-input placeholder="Relationship" v-model="input"></el-input>
          </el-form-item>
          <el-form-item prop label="Phone Number">
            <vue-tel-input
              class="input"
              name="phoneNumber"
              :preferredCountries="['ng', 'us', 'uk']"
              @keypress.native="onlyNumbers"
            ></vue-tel-input>
          </el-form-item>
          <el-form-item prop="contact_address" label="Address">
            <el-input type="textarea" :rows="5" placeholder="Address" v-model="textarea"></el-input>
          </el-form-item>-->
              </div>
              <div class="employee-signup-avatar">
                <el-upload
                  :loding="loading"
                  class="avatar-uploader"
                  action
                  :limit="1"
                  :show-file-list="true"
                  :auto-upload="false"
                  :on-change="handleAvatarSuccess"
                >
                  <img
                    v-if="createEmployeeForm.picture"
                    :src="createEmployeeForm.picture"
                    style="max-width:100px"
                    class="avatar"
                  />
                  <img
                    v-else
                    src="/img/upload.svg"
                    class="employee-signup-avatar"
                    alt="avatar"
                  />
                </el-upload>
              </div>
              <div class="btn-wrapper">
                <el-button
                  @click.prevent="prev()"
                  class="btn btn-big btn-blue btn-full-radius mt-60 ml-auto bold mt-60"
                  >&lt; Previous</el-button
                >
                <el-button
                  @click.prevent="next()"
                  class="btn btn-big btn-light-gray no-border btn-full-radius inline-flex flex-v-end float-r mt-60"
                >
                  Continue >
                </el-button>
              </div>
            </div>
            <div class="step" v-show="step === 3">
              <h3 class="mt-0 mb-0 grid-full">
                {{ title }} Employee <span v-if="step === 2">(cont.)</span>
              </h3>
              <div class="form-left">
                <h3>Employee Information</h3>
                <el-form-item
                  prop="appointment_date"
                  label="Date of Employment"
                >
                  <el-date-picker
                    v-model="createEmployeeForm.appointment_date"
                    type="date"
                    placeholder="Pick date"
                    value-format="yyyy-MM-dd"
                    format="dd-MM-yyyy"
                    :picker-options="pickerOptions"
                    disabled
                  ></el-date-picker>
                </el-form-item>
                <el-form-item prop="branch_id" label="Branch">
                  <el-select
                    v-model="createEmployeeForm.branch_id"
                    placeholder="Branch"
                    class="flex-1"
                    name="branch_id"
                    filterable
                    remote
                    clearable
                    :remote-method="searchBranch"
                    disabled
                  >
                    <el-option
                      v-for="item in branchOptions"
                      :key="item.id"
                      :label="item.station_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="department_id" label="Department">
                  <el-select
                    v-model="createEmployeeForm.department_id"
                    placeholder="Department"
                    class="flex-1"
                    filterable
                    remote
                    clearable
                    :remote-method="searchDepartment"
                    disabled
                  >
                    <el-option
                      v-for="item in departmentOptions"
                      :key="item.id"
                      :label="item.department_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="employee_type_id" label="Employee Type">
                  <el-select
                    v-model="createEmployeeForm.employee_type_id"
                    placeholder="Employee Type"
                    class="flex-1"
                    filterable
                    remote
                    clearable
                    :remote-method="searchEmployeeType"
                    disabled
                  >
                    <el-option
                      v-for="item in employeeTypeOptions"
                      :key="item.id"
                      :label="item.type_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="employee_category_id"
                  label="Employee Category"
                >
                  <el-select
                    v-model="createEmployeeForm.employee_category_id"
                    placeholder="Employee Category"
                    class="flex-1"
                    filterable
                    remote
                    clearable
                    :remote-method="searchEmployeeCategory"
                    disabled
                  >
                    <el-option
                      v-for="item in employeeCategoryOptions"
                      :key="item.id"
                      :label="item.category_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="employee_designation_id"
                  label="Employee Designation"
                >
                  <el-select
                    v-model="createEmployeeForm.employee_designation_id"
                    placeholder="Employee Designation"
                    class="flex-1"
                    filterable
                    remote
                    clearable
                    :remote-method="searchEmployeeDesignation"
                    disabled
                  >
                    <el-option
                      v-for="item in employeeDesignationOptions"
                      :key="item.id"
                      :label="item.designation_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="employee_grade_id" label="Employee Grade">
                  <el-select
                    v-model="createEmployeeForm.employee_grade_id"
                    placeholder="Employee Grade"
                    class="flex-1"
                    filterable
                    remote
                    clearable
                    :remote-method="searchEmployeeGrade"
                    disabled
                  >
                    <el-option
                      v-for="item in employeeGradeOptions"
                      :key="item.id"
                      :label="item.grade_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <h3>Bank/Pension Details</h3>
                <el-form-item label="Bank Name">
                  <el-select
                    v-model="createEmployeeForm.bank_id"
                    placeholder="Bank Name"
                    class="flex-1"
                    name="bank_id"
                    filterable
                    remote
                    clearable
                  >
                    <el-option
                      v-for="item in banks"
                      :key="item.id"
                      :label="item.bank_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Account Number">
                  <el-input
                    placeholder="Type your account number"
                    name="accountNumber"
                    v-model="createEmployeeForm.account_number"
                    type="number"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Bank Branch">
                  <el-input
                    placeholder="Type Bank Branch"
                    name="bankBranch"
                    v-model="createEmployeeForm.bank_branch"
                  ></el-input>
                </el-form-item>
                <el-form-item label="PFA">
                  <el-input
                    placeholder="PFA"
                    name="pfa"
                    v-model="createEmployeeForm.pension_fund_administrator"
                  ></el-input>
                </el-form-item>
                <el-form-item label="RSA Pin">
                  <el-input
                    placeholder="Type your RSA Pin"
                    v-model="createEmployeeForm.rsa_pin"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Tax ID">
                  <el-input
                    placeholder="Type your Tax ID"
                    v-model="createEmployeeForm.tax_id"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Tax Location">
                  <el-input
                    placeholder="Type your tax location"
                    v-model="createEmployeeForm.tax_location"
                  ></el-input>
                </el-form-item>

                <h3>User Information</h3>
                <!-- <el-form-item label="username">
            <el-input placeholder="Ayobami" name="username"></el-input>
          </el-form-item>
          <el-form-item label="password">
            <el-input placeholder="Head Office" type="password" name="password"></el-input>
          </el-form-item>
          <el-form-item label="Confirm Password">
            <el-input
              placeholder="Re-type your password"
              type="password"
              v-model="confirmPassword"
              name="confirmPassword"
            ></el-input>
          </el-form-item>-->
                <el-form-item prop="roles" label="Permision Level">
                  <el-select
                    v-model="createEmployeeForm.roles"
                    multiple
                    placeholder="Select Roles"
                    disabled
                  >
                    <el-option
                      v-for="role in roles"
                      :key="role.id"
                      :label="role.name"
                      :value="role.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="Email">
            <el-input placeholder="Test@sbtelecoms.com" type="email"></el-input>
          </el-form-item>-->
                <el-form-item label="Access Pin" prop="pin" v-if="!isEdit">
                  <el-input
                    placeholder="132"
                    type="number"
                    v-model.number="createEmployeeForm.pin"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Access Pin" v-else>
                  <p>{{ createEmployeeForm.pin }}</p>
                </el-form-item>
                <!-- <h3>Reporting</h3>
          <el-form-item label="Reports To">
            <div class="relative">
              <el-select v-model="value" placeholder="Reports To" class="flex-1">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <button class="btn no-border btn-full-radius btn-gray addrl">Add RL</button>
            </div>
          </el-form-item>
          <el-form-item label="Reports To">
            <el-select v-model="value" placeholder="Reports To">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Supervisor">
            <el-select v-model="value" placeholder="Supervisor">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>-->
              </div>
              <div class="btn-wrapper">
                <el-button
                  @click.prevent="prev()"
                  class="btn btn-big btn-blue btn-full-radius mt-60 ml-auto bold mt-60"
                  >&lt; Previous</el-button
                >
                <el-button
                  @click.prevent="update()"
                  class="btn btn-big btn-light-gray no-border btn-full-radius inline-flex flex-v-end float-r mt-60"
                  :loading="loading"
                >
                  Save >
                </el-button>
              </div>
            </div>
          </el-form>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { getPropertyById, getIdByProperty } from "@/helpers/functions";
import { onlyNumbers } from "@/helpers/validation.js";
const { mapActions } = createNamespacedHelpers("admin/organization/employee");
import debounce from "lodash.debounce";
import VuePhoneNumberInput from "vue-phone-number-input";
export default {
  components: {
    VuePhoneNumberInput,
  },
  mounted() {
    this.loading = true;
    this.id = this.$user.getEmployee().id;
    this.isEdit = this.id ? true : false;
    this.title = this.isEdit ? "Edit" : "Create New";

    if (!this.id) {
      // this.loading = false;
      // this.getCountries();
      // this.getBanks();
      this.$router.push("/login");
      return;
    }
    if (this.id) {
      this.getBanks();
      this.getEmployeesById(this.id)
        .then(response => {
          const data = response.data;
          const {
            employee_category,
            employee_designation,
            employee_grade,
            employee_type,
            branch,
            roles,
            first_name,
            last_name,
            department,
          } = data;

          this.firstName = first_name;
          this.lastName = last_name;
          this.employeeTypeOptions = [employee_type];
          this.employeeCategoryOptions = [employee_category];
          this.branchOptions = [branch];
          this.employeeDesignationOptions = [employee_designation];
          this.employeeGradeOptions = [employee_grade];
          this.departmentOptions = [department];
          this.roles = roles;

          let formatedData = this.formatWithKeys(data, this.createEmployeeForm);
          formatedData = {
            ...formatedData,
            roles: formatedData.roles.map(x => x.id),
          };
          this.createEmployeeForm = formatedData;
          this.processPhone(this.createEmployeeForm.mobile_number);
          this.getCountries();
          this.loading = false;
          return;
        })
        .catch(error => {
          this.$notification.error(error.message);
        });
    }
  },
  data() {
    const validateEqualPhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (value === this.createEmployeeForm.mobile_number) {
        callback(new Error("Phone number already used"));
      } else {
        callback();
      }
    };
    return {
      banks: [],
      genderOptions: [
        {
          label: "Male",
          value: "male",
        },
        {
          label: "Female",
          value: "female",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      firstName: "",
      lastName: "",
      id: null,
      isEdit: false,
      title: "",
      step: 1,
      maxStep: 4,
      branches: [],
      branchOptions: [],
      department: [],
      departmentOptions: [],
      employeeTypes: [],
      employeeTypeOptions: [],
      employeeCategories: [],
      employeeCategoryOptions: [],
      employeeDesignations: [],
      employeeDesignationOptions: [],
      employeeGrades: [],
      employeeGradeOptions: [],
      countries: [],
      cities: [],
      states: [],
      options: [],
      roles: [],
      value: "",
      date: "",
      input: "",
      textarea: "",
      loading: false,
      text: "",
      confirmPassword: "",
      othersText: "",
      phone: "",

      maritalStatusOptions: [
        {
          label: "Married",
          value: "married",
        },
        {
          label: "Single",
          value: "single",
        },
      ],
      salutationOptions: [
        {
          label: "Mr",
          value: "mr",
        },
        {
          label: "Mrs",
          value: "mrs",
        },
        {
          label: "Miss",
          value: "miss",
        },
      ],
      rules: {
        mobile_number2: [
          { validator: validateEqualPhoneNumber, trigger: "change" },
        ],
        mobile_number: [
          {
            type: "string",
            required: true,
            message: "Kindly input a phone number",
            trigger: "change",
          },
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "Kindly input a valid email",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: false,
            message: "Kindly select a country",
            trigger: "change",
          },
        ],
        state: [
          {
            required: false,
            message: "Kindly select a State",
            trigger: "change",
          },
        ],
        city: [
          {
            required: false,
            message: "Kindly select a City",
            trigger: "change",
          },
        ],
        address: [
          {
            required: false,
            message: "Kindly input Address",
            trigger: "change",
          },
        ],
        marital_status: [
          {
            type: "string",
            required: false,
            message: "Kindly select Marital Status",
            trigger: "change",
          },
        ],
        salutation: [
          {
            type: "string",
            required: false,
            message: "Kindly select Salutation",
            trigger: "change",
          },
        ],
        branch_id: [
          {
            type: "number",
            required: false,
            message: "Kindly select a branch",
            trigger: "change",
          },
        ],
        department_id: [
          {
            type: "number",
            required: false,
            message: "Kindly select a department",
            trigger: "blur",
          },
        ],
        employee_type_id: [
          {
            type: "number",
            required: false,
            message: "Kindly select an Employee Type",
            trigger: "change",
          },
        ],
        employee_designation_id: [
          {
            type: "number",
            required: false,
            message: "Kindly select a Job Designation",
            trigger: "change",
          },
        ],
        employee_grade_id: [
          {
            type: "number",
            required: false,
            message: "Kindly select a Grade",
            trigger: "change",
          },
        ],
        employee_category_id: [
          {
            type: "number",
            required: false,
            message: "Kindly select a Category",
            trigger: "change",
          },
        ],
        first_name: [
          {
            type: "string",
            required: true,
            message: "Kindly input Firstname",
            trigger: "change",
          },
        ],
        last_name: [
          {
            type: "string",
            required: true,
            message: "Kindly input Lastname",
            trigger: "change",
          },
        ],
        gender: [
          {
            type: "string",
            required: false,
            message: "Kindly select a Gender",
            trigger: "change",
          },
        ],
        password: [
          {
            type: "string",
            required: false,
            message: "Kindly input your password",
            trigger: "change",
          },
        ],
        nationality: [
          {
            type: "string",
            required: false,
            message: "Kindly input your nationality",
            trigger: "change",
          },
        ],
      },
      createEmployeeForm: {
        branch_id: null,
        department_id: null,
        employee_type_id: null,
        employee_designation_id: null,
        employee_grade_id: null,
        employee_category_id: null,
        salutation: "",
        gender: "",
        date_of_birth: "",
        first_name: "",
        last_name: "",
        blood_group: "",
        marital_status: "",
        religion: "",
        email: "",
        mobile_number: null,
        mobile_number2: null,
        address: "",
        country: "",
        state: "",
        city: "",
        login_access: false,
        nationality: "",
        roles: [],
        banks: [],
        pin: null,
        picture: "",
        bank_id: "",
        account_number: "",
        bank_branch: "",
        pension_fund_administrator: "",
        rsa_pin: "",
        tax_id: "",
        appointment_date: "",
        tax_location: "",
      },
    };
  },
  methods: {
    onlyNumbers,
    ...mapActions(["getEmployeesById"]),
    getBanks() {
      this.$store
        .dispatch("fetchBanks")
        .then(response => {
          this.banks = response.data;
        })
        .catch();
    },
    logout() {
      this.$user.clearStorage();
      this.$router.push({ name: "companyUrl" });
    },
    prev() {
      if (this.step <= 1) return;
      this.step--;
    },
    next() {
      if (this.step >= 2) {
        this.$refs[`createEmployeeForm`].validate(valid => {
          if (!valid) return;
          if (this.step >= this.maxStep) return;
          this.step++;
        });
        return;
      }
      this.step++;
    },
    scroll() {
      const errorElements = document.querySelectorAll(".el-form-item__error");
      const lastElement = errorElements.length
        ? errorElements[errorElements.length - 1]
        : null;
      const options = {
        offset: -60,
      };

      this.$scrollTo(
        lastElement || document.getElementById("createEmployeeForm"),
        500,
        options
      );
    },
    formatWithKeys(object, objectKeys) {
      const formatedObj = {};
      const allowedKeys = Object.keys(objectKeys);
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          if (
            allowedKeys.includes(key) &&
            (Array.isArray(object[key]) || typeof object[key] !== "object")
          ) {
            formatedObj[key] = object[key];
          }
        }
      }
      return formatedObj;
    },
    processPhone(x) {
      if (x !== undefined && this.id) {
        const dash = x.search("-");
        if (dash > 0) {
          const phone = x.split("-", 2);
          this.createEmployeeForm.mobile_number = phone[1];
          this.phone = phone[1];
        } else {
          this.createEmployeeForm.mobile_number = this.createEmployeeForm.mobile_number;
          this.phone = this.createEmployeeForm.mobile_number;
        }
      }
    },
    phoneFormatted(x) {
      if (x.phoneNumber.search("-") < 0) {
        this.phone = x.countryCode + "-" + this.sliceFirstLetter(x.phoneNumber);
        return;
      }
      this.phone = x.phoneNumber;
    },
    sliceFirstLetter(phone) {
      if (phone) {
        const phone_no = phone.charAt(0);
        return phone_no == 0 ? phone.slice(1).replace(/ +/g, "") : phone;
      }
    },
    update() {
      this.$refs[`createEmployeeForm`].validate(valid => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        delete this.createEmployeeForm.mobile_number2;
        const formData = {
          ...this.createEmployeeForm,
          ...(!this.isEdit && {
            pin: parseInt(this.createEmployeeForm.pin),
          }),
          religion:
            this.createEmployeeForm.religion === "others"
              ? this.othersText
              : this.createEmployeeForm.religion,
          country: getPropertyById(
            this.countries,
            "name",
            this.createEmployeeForm.country
          ),
          state: getPropertyById(
            this.states,
            "name",
            this.createEmployeeForm.state
          ),
          city: getPropertyById(
            this.cities,
            "name",
            this.createEmployeeForm.city
          ),
          login_access: !!this.createEmployeeForm.roles.length,
          mobile_number: this.phone,
          profile_completed: true,
        };
        if (this.id) {
          const employeeUpdateData = { ...formData };
          delete employeeUpdateData.pin; //pin is not allowed

          this.$store
            .dispatch("admin/organization/employee/updateEmployeeAfterInvite", {
              data: employeeUpdateData,
              id: this.id,
            })
            .then(response => {
              this.loading = false;
              this.$notification.success(response.message);
              this.$router.push({ name: "ess" });
            })
            .catch(error => {
              this.loading = false;
              this.$notification.error(error.message);
            });
          return;
        }
      });
    },
    getCountries() {
      this.$store
        .dispatch("fetchCountries")
        .then(response => {
          this.countries = response.data;

          //for edit
          if (this.id && this.createEmployeeForm.country) {
            const countryId = getIdByProperty(
              this.countries,
              "name",
              this.createEmployeeForm.country
            );
            this.getStates(countryId);
          }
        })
        .catch(() => {
          // this.$notification.error(error.message);
        });
    },
    getStates(id) {
      this.$store
        .dispatch("fetchStates", { countryId: id })
        .then(response => {
          this.states = response.data;

          if (this.id && this.createEmployeeForm.state) {
            const stateId = getIdByProperty(
              this.states,
              "name",
              this.createEmployeeForm.state
            );
            this.getCities(stateId);
          }
        })
        .catch(() => {
          // this.$notification.error(error.message);
        });
    },
    getCities(id) {
      this.$store
        .dispatch("fetchCities", { stateId: id })
        .then(response => {
          this.cities = response.data;
        })
        .catch(() => {
          // this.$notification.error(error.message);
        });
    },

    handleAvatarSuccess(file) {
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/jpg";
      const isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$notification.error("Avatar picture must be JPG format!");
        return;
      }
      if (!isLt2M) {
        this.$notification.error("Avatar picture size can not exceed 2MB!");
        return;
      }
      this.loading = true;
      const data = new FormData();
      data.append("employeePicture", file.raw);

      this.$store
        .dispatch("admin/organization/employee/imageUpload", data)
        .then(response => {
          this.createEmployeeForm.picture = response;
          this.loading = false;
          this.$notification.success(response.message);
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
    searchBranch: debounce(function(query) {
      if (query.trim() !== "") {
        this.branchOptions = this.branches.filter(item => {
          return (
            item.station_name.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        });
        return;
      }
      this.branchOptions = this.branches;
    }),
    searchDepartment: debounce(function(query) {
      if (query.trim() !== "") {
        this.departmentOptions = this.department.filter(item => {
          return (
            item.department_name.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        });
        return;
      }
      this.departmentOptions = this.department;
    }),
    searchEmployeeType: debounce(function(query) {
      if (query.trim() !== "") {
        this.employeeTypeOptions = this.employeeTypes.filter(item => {
          return item.type_name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
        return;
      }
      this.employeeTypeOptions = this.employeeTypes;
    }),
    searchEmployeeCategory: debounce(function(query) {
      if (query.trim() !== "") {
        this.employeeCategoryOptions = this.employeeCategories.filter(item => {
          return (
            item.category_name.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        });
        return;
      }
      this.employeeCategoryOptions = this.employeeCategories;
    }),
    searchEmployeeDesignation: debounce(function(query) {
      if (query.trim() !== "") {
        this.employeeDesignationOptions = this.employeeDesignations.filter(
          item => {
            return (
              item.designation_name.toLowerCase().indexOf(query.toLowerCase()) >
              -1
            );
          }
        );
        return;
      }
      this.employeeDesignationOptions = this.employeeDesignations;
    }),
    searchEmployeeGrade: debounce(function(query) {
      if (query.trim() !== "") {
        this.employeeGradeOptions = this.employeeGrades.filter(item => {
          return (
            item.grade_name.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        });
        return;
      }
      this.employeeGradeOptions = this.employeeGrades;
    }),
  },
};
</script>

<style>
.addrl {
  position: absolute;
  top: 0;
  right: -120px;
  margin-left: 10px;
}

.info-right .media-group {
  display: grid !important;
  grid-template-columns: 24px auto auto;
  grid-gap: 20px;
}

.get-started-container {
  height: 100%;
}
.get-started .info {
  display: grid;
  grid-template-columns: 1fr 300px;
  grid-gap: 30px;
}
.radio-group label {
  display: inline-block;
  cursor: pointer;
  margin-bottom: 10px;
}

.radio-group input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-group .radio-label {
  display: inline-block;
  background: #f5f7fa;
  border: 0.75px solid #888888;
  padding: 8px 25px;
  border-radius: 4px;
}

input[type="radio"]:checked + .radio-label {
  background-color: var(--blue);
  color: #fff;
  transition: background-color 300ms ease;
  border: none;
}

.get-started .form-control {
  display: grid !important;
  grid-template-columns: 150px 1fr;
}

.get-started .header {
  padding: 10px 30px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
  grid-column: 1/-1;
}

.get-started .btn-gray {
  background-color: var(--dark-gray);
  color: #fff;
}

.get-started {
  display: grid;
  grid-template-columns: 250px 1fr;
  line-height: 26px;
  height: 100%;
  /* font-size: 14px; */
}

.get-started .aside {
  background-color: var(--deep-blue);
  min-height: 100vh;
  padding: 25px;
  height: 100%;
  overflow: auto;
}

.get-started .aside .logo {
  font-size: 40px;
  color: #fff;
  text-transform: uppercase;
}

.get-started .main {
  padding: 40px;
  height: 100%;
  overflow: auto;
}

p {
  margin-bottom: 15px;
}

.media-group > *:not(:last-child) {
  margin-right: 15px;
}

.media-group a:not(:last-child) {
  padding-left: 12px;
}

.form-container {
  max-width: 700px;
}

.get-started .form-panel {
  overflow: hidden !important;
  padding: 0 30px;
}

input[type="text"],
input[type="tel"],
input[type="email"],
input[type="number"],
input[type="password"],
textarea,
.get-started .vue-tel-input,
.get-started .el-date-editor.el-input,
.get-started .el-select,
select {
  width: 100% !important;
  max-width: 542px !important;
}

.employee-signup-form {
  display: grid;
  grid-template-columns: 1fr 180px;
  grid-gap: 30px;
}

.employee-signup-form h2,
.btn-wrapper {
  grid-column: 1/-1;
}

.employee-signup-avatar {
  padding-top: 75px;
  width: 90%;
}

.form-left {
  max-width: 700px;
  /* margin: 0 auto; */
}

@media (max-width: 1317px) {
  .get-started {
    grid-template-columns: 1fr;
  }

  .get-started .aside {
    display: none;
  }

  .get-started.step-1 .main {
    padding: 30px;
    max-width: 1050px;
    min-height: 100vh;
    margin: 0 auto;
    padding-left: 30px;
    padding-right: 30px;
    grid-gap: 20px;
    width: 100%;
  }
}

@media (max-width: 1250px) {
  .addrl {
    position: static;
    margin-top: 20px;
    margin-left: 0;
  }
  .employee-signup-form {
    grid-template-columns: 1fr;
  }

  .employee-signup-form h2 {
    order: -1;
    justify-self: center;
  }

  .employee-signup-avatar {
    padding: 0;
    order: 1;
    width: 35%;
    justify-self: center;
  }

  .form-left,
  .btn-wrapper {
    order: 2;
  }
  .get-started .main {
    padding-left: 0;
    padding-right: 0;
  }

  .get-started.step-1 .main {
    padding-left: 30px;
    padding-right: 30px;
  }
}

@media (max-width: 760px) {
  .employee-signup-avatar {
    width: 48%;
  }

  .btn-big {
    padding: 10px 30px;
  }
}

@media (max-width: 650px) {
  .get-started .form-control {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 700px) {
  .get-started .info {
    grid-template-columns: 1fr;
  }
}
</style>
